var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"widget"}},[_c('div',{attrs:{"id":"unmudl-widget"}},[(_vm.isAuthenticated)?[(_vm.programs && _vm.programs.length > 0)?_c('div',[_c('unmudl-explore-program-list',{attrs:{"type":_vm.type,"programs":_vm.programs,"institution-id":_vm.targetInstitutionId,"course-title":_vm.courseTitle}})],1):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258ebb43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/UnmudlWebWidgetApp.vue
// module id = null
// module chunks = 